import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function Civil() {
  return (
    <Layout page={<div>
      <h1>Civil</h1>
      <h3>Module 1</h3>
      <ul>
        <Link to='/file/civil/Module 1 - Notes.pdf'>Module 1 - Notes.pdf</Link>
      </ul>
      <h3>Text Book</h3>
      <ul>
        <Link to='/file/civil/(by-GANESH-B.-MOGAVEER,-M.-N.-SHESHA-PRAKASH)-Elem-3485515-(z-lib.org) (1).pdf'>(by-GANESH-B.-MOGAVEER,-M.-N.-SHESHA-PRAKASH)-Elem-3485515-(z-lib.org) (1).pdf</Link>
      </ul>
      <h3>More Notes</h3>
      <ul>
        <Link to='/file/civil/Kinematics_Kinetics.pdf'>Kinematics_Kinetics.pdf</Link>
        <Link to='/file/civil/Analysis of Trusses.pdf'>Analysis of Trusses</Link>
        <Link to='/file/civil/BEAMS.pdf'>BEAMS.pdf</Link>
        <Link to='/file/civil/Support-Reactions.pdf'>Support-Reactions.pdf</Link>
        <Link to='/file/civil/Model QP with solution civil.pdf'>Model QP with solution civil.pdf</Link>
      </ul>
    </div>} />
  )
}
